import { useCallback, useState } from 'react';

export default function useToggle(initiallyOpen = false, { onOpen, onClose } = {}) {
    const [isOpen, setOpen] = useState(initiallyOpen);

    const open = useCallback(() => {
        setOpen(true);
        typeof onOpen === 'function' && onOpen();
    }, [onOpen]);

    const close = useCallback(() => {
        setOpen(false);
        typeof onClose === 'function' && onClose();
    }, [onClose]);

    return [isOpen, open, close];
}
